if (!customElements.get('vyv-local-stops')) customElements.define('vyv-local-stops', class extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController();
  const {signal} = this.controller;
  const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, {...options, signal});
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const slides = [...this.querySelectorAll('[data-stop]')];
  const dots = [...this.querySelectorAll('[data-stop-go]')];
  const toggle = this.querySelector('[data-stop-toggle]');
  const count = this.querySelector('[data-stop-current]');
  let index = 0, paused = reduced.matches, visible = false, focused = false;
  const schedule = () => {
   clearTimeout(this.timer);
   if (!signal.aborted && !paused && visible && !focused && !document.hidden)
    this.timer = setTimeout(() => show(index + 1), 4000);
  };
  const show = next => {
   index = (next + slides.length) % slides.length;
   slides.forEach((slide, i) => {
    slide.classList.toggle('is-active', i === index);
    slide.inert = i !== index;
    slide.setAttribute('aria-hidden', String(i !== index));
   });
   dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
   count.textContent = String(index + 1).padStart(2, '0');
   this.dataset.current = index;
   schedule();
  };
  const status = () => {
   toggle.setAttribute('aria-label', paused ? 'Start automatic rotation' : 'Pause automatic rotation');
   toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
   this.querySelector('.local-stops__count').setAttribute('aria-live', paused ? 'polite' : 'off');
   schedule();
  };
  const manual = next => { show(next); status(); };
  on(this.querySelector('[data-stop-prev]'), 'click', () => manual(index - 1));
  on(this.querySelector('[data-stop-next]'), 'click', () => manual(index + 1));
  dots.forEach((dot, i) => on(dot, 'click', () => manual(i)));
  on(toggle, 'click', () => { paused = !paused; status(); });
  on(this, 'keydown', event => {
   if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
    event.preventDefault(); manual(index + (event.key === 'ArrowRight' ? 1 : -1));
   }
  });
  on(this, 'focusin', event => { focused = event.target.matches(':focus-visible'); schedule(); });
  on(this, 'focusout', () => queueMicrotask(() => { focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); schedule(); }));
  on(this, 'pointerdown', () => { focused = false; schedule(); });
  let start;
  on(this, 'touchstart', event => { start = {x: event.touches[0].clientX, y: event.touches[0].clientY}; }, {passive: true});
  on(this, 'touchend', event => {
   if (!start) return;
   const dx = event.changedTouches[0].clientX - start.x, dy = event.changedTouches[0].clientY - start.y;
   if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) manual(index + (dx < 0 ? 1 : -1));
   start = null;
  }, {passive: true});
  this.observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); }, {threshold: .25});
  this.observer.observe(this);
  on(document, 'visibilitychange', schedule);
  on(reduced, 'change', () => { if (reduced.matches) { paused = true; status(); } });
  show(0); status();
 }
 disconnectedCallback() {
  clearTimeout(this.timer);
  this.controller?.abort(); this.controller = null;
  this.observer?.disconnect();
 }
});
